import { useIntl } from 'react-intl'
import hocClubCard from './hocClubCard'

import FormRegisterClub from '../../../../components/Forms/FormRegisterClub/FormRegisterClub'
import Typography from '../../../../components/Typography/Typography'

import { PATH_NAME } from 'app/constants'
import { useState } from 'react'
import './ClubCard.scss'
import OrderMembershipButton from './components/OrderMembershipButton'
import ProlongMembershipButton from './components/ProlongMembershipButton'

const ClubCard = ({
    points,
    isExpiring,
    isClubMember,
    cinemaid,
    setCardProlonge,
    cardsInBasket,
    removeCard,
    registerClub,
    isAuth,
    push,
}) => {
    const intl = useIntl()
    const [showRegistration, setShowRegistration] = useState(false)

    const pointsRounded = Math.round(points * 100) / 100
    const handleCardProlonge = () => {
        setCardProlonge({ cinemaid })
    }

    const handleRemoveCard = (cardid) => {
        removeCard({ cardid })
    }

    return (
        <>
            {/* Modal window with registration form*/}
            <FormRegisterClub
                show={showRegistration}
                handleSubmit={registerClub}
                onHide={() => setShowRegistration(!showRegistration)}
            />

            <div className="club-card d-flex flex-column position-relative">
                <img src={'images/cards/cinestar-club.png'} alt={'club-card'} className={'position-absolute'} />
                <Typography variant={'sectionHeadline'}>
                    {intl.formatMessage({ id: 'userProfile.cinestarClub.title' })}
                </Typography>

                {
                    /* User not auth */
                    !isAuth && (
                        <>
                            <Typography variant={'span'} className={'club-card--sale'}>
                                {intl.formatMessage({ id: 'orderSummary.getSale' })}
                            </Typography>
                            <OrderMembershipButton
                                cardsInBasket={cardsInBasket}
                                setShowRegistration={() => push(PATH_NAME.REGISTER)}
                                removeCard={() => handleRemoveCard(cardsInBasket[0].cardid)}
                            />
                        </>
                    )
                }

                {
                    //User card ok
                    isClubMember && !isExpiring && (
                        <div className="d-flex gap-2 text-nowrap opacity-50">
                            <Typography variant={'span'}>
                                {intl.formatMessage({ id: 'orderSummary.haveAvailable' })}
                            </Typography>
                            <Typography variant={'span'}>
                                {intl.formatMessage({ id: 'global.currency.points' }, { points: pointsRounded })}
                            </Typography>
                        </div>
                    )
                }

                {
                    //No card but registred
                    isAuth && !isClubMember && !isExpiring && (
                        <>
                            <Typography variant={'span'} className={'club-card--sale'}>
                                {intl.formatMessage({ id: 'orderSummary.getSale' })}
                            </Typography>

                            <OrderMembershipButton
                                cardsInBasket={cardsInBasket}
                                setShowRegistration={() => setShowRegistration(true)}
                                removeCard={() => handleRemoveCard(cardsInBasket[0].cardid)}
                            />
                        </>
                    )
                }

                {
                    //Already expired or will expire soon
                    isExpiring && (
                        <ProlongMembershipButton
                            cardsInBasket={cardsInBasket}
                            handleCardProlonge={() => handleCardProlonge()}
                            removeCard={() => handleRemoveCard(cardsInBasket[0].cardid)}
                        />
                    )
                }
            </div>
        </>
    )
}

export default hocClubCard(ClubCard)
